import React from "react";
import type { IFormItemLayout, TWealthSourceOfOwner } from "@adgm/cross-models";
import MultiCheckboxSubForm from "./MultiCheckboxSubForm";
import { WEALTH_SOURCE_OF_OWNER_CONFIG } from "./WealthSourceOfOwnerFormConfig";

interface IProps extends IFormItemLayout<TWealthSourceOfOwner | null> {
  value?: TWealthSourceOfOwner | null;
  onChange: (value: TWealthSourceOfOwner) => void;
  style?: any; // 显式声明 style 属性
}

/**
 * 所有者财富来源表单组件
 * 用于输入最终受益所有人的财富来源信息
 *
 * @description
 * 此组件已重构为使用通用的 MultiCheckboxSubForm 组件，
 * 通过配置对象驱动，保持向后兼容。
 */
export const WealthSourceOfOwnerForm: React.FC<IProps> = props => {
  return (
    <MultiCheckboxSubForm<TWealthSourceOfOwner> {...props} config={WEALTH_SOURCE_OF_OWNER_CONFIG} />
  );
};
